module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/error403-landscape_5c11c0f.png";